import React from "react";
import DataGrid, { IColumnProps } from "devextreme-react/data-grid";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import { createGridOptions, remoteReadOnlyGridOptions, StdGrid, createEncryptedStringColumn} from "../../components";
import { customerComplainStore } from "../../api";
import { StringMap } from "../../base";
import { CustomerComplainModel } from "../../models";

export interface CustomerComplainGridProps {
    onButtonClick: (model: CustomerComplainModel, name: string) => void;
    onModelSelected: (model: CustomerComplainModel) => void;
}

interface CustomerComplainGridState {
    columns: IColumnProps[];
}

export default class CustomerComplainGrid 
    extends React.Component<CustomerComplainGridProps, CustomerComplainGridState> {
    moduleName = "CustomerComplain";
    gridRef = React.createRef<DataGrid>();
    gridOptions = createGridOptions("customerComplains", this.gridRef, remoteReadOnlyGridOptions);
    nameMap: StringMap = { "customer.name": "customerId" };

    constructor(props: Readonly<CustomerComplainGridProps>) {
        super(props);

        this.state = {
            columns: [
                { dataField: "organizationName" },
                { dataField: "deliverName" },
                {
                    dataField: "customer.name",
                    cellRender: e => {
                        return <span>{e.data.customer.name}（{e.data.customer.gasCode}）</span>
                    }
                },
                { dataField: "customerName" },
                createEncryptedStringColumn({ dataField: "phoneNumber" }),
                { dataField: "complainTime" },
                { dataField: "complainType" },
                { dataField: "complainContent" },
                { dataField: "handleTime", dataType: "datetime" },
                { dataField: "result" }
            ]
        };

        this.gridOptions.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptions.onRowDblClick = e => this.props.onButtonClick(e.data, "edit");
    }

    refresh() {
        this.gridRef.current?.instance.refresh();
    }

    onSelectionChanged(e: SelectionChangedEvent) {
        if (e.selectedRowsData.length === 1) {
            this.props.onModelSelected(e.selectedRowsData[0]);
        } else {
            this.props.onModelSelected({});
        }
    }

    filter(filterValue: any) {
        this.gridRef.current?.instance.filter(filterValue);
    }

    render() {
        return (
            <StdGrid
                moduleName={this.moduleName}
                gridRef={this.gridRef}
                dataSource={customerComplainStore}
                options={this.gridOptions}
                columnNameMap={this.nameMap}
                columns={this.state.columns}>
            </StdGrid>
        )
    }
}

